import { FancySharesRequestDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { QueryKey } from 'constants/reactQuery';

export const fancyShareQueryKey = {
  fancyShare: (fancyShareId: number) => [QueryKey.FancyShare, fancyShareId] as const,
  fancyShares: QueryKey.FancyShare as const,

  fancyShareProfileRoot: (profileId: number, includeAdult: boolean) =>
    [fancyShareQueryKey.fancyShares, QueryKey.Profile, profileId, includeAdult] as const,
  fancyShareProfileList: (profileId: number, includeAdult: boolean) =>
    [...fancyShareQueryKey.fancyShareProfileRoot(profileId, includeAdult)] as const,
  fancyShareProfileCount: (profileId: number, includeAdult: boolean) =>
    [...fancyShareQueryKey.fancyShareProfileRoot(profileId, includeAdult), 'count'] as const,

  fancyShareContentRoot: (contentId: number, includeAdult: boolean) =>
    [fancyShareQueryKey.fancyShares, QueryKey.Content, contentId, includeAdult] as const,

  fancyShareRoot: (includeAdult: boolean) => [fancyShareQueryKey.fancyShares, includeAdult] as const,
  fancyShareList: ({ includeAdult, categoryIds }: FancySharesRequestDto) =>
    [...fancyShareQueryKey.fancyShareRoot(includeAdult), categoryIds?.slice().sort()] as const,

  fancyShareLikes: [QueryKey.FancyShare, 'likes'] as const,
  fancyShareLikeList: (fancyShareIds: number[]) =>
    [...fancyShareQueryKey.fancyShareLikes, fancyShareIds.join('|')] as const,

  canUploadFancyShare: (contentId: number, episodeId: number) => [QueryKey.FancyShare, contentId, episodeId] as const,
};
